import { render } from "./menu-btn.vue?vue&type=template&id=673dd436&ts=true"
import script from "./menu-btn.vue?vue&type=script&lang=ts"
export * from "./menu-btn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__